import { z } from 'zod'
import { oc } from '@orpc/contract'

// Practice-wide lab order sets, visible to every practitioner in the caller's
// organization(s) — as opposed to the per-practitioner panels web stores on a
// Practitioner extension.
//
// Read-only for now: PD-1479 only requires that all practitioners can SEE and
// USE the shared panels. Letting practitioners author their own shared panels is
// deliberately deferred, so there is no set/delete route yet.
//
// `vendor` narrows to one lab ('labcorp' | 'quest' | 'accureference'); omit it to
// get every shared panel the caller can see.
//
// `tests[].code` is the vendor's own order code — exactly what the requisition
// submits. `tests[].name` is resolved server-side from the seeded catalog so the
// UI can show legible names without loading the whole catalog first, and is
// `null` when the code is not in our catalog (the seeded Labcorp set is far
// smaller than Labcorp's real menu). A null name means "show the raw code", not
// an error.
//
// `tests[].category`/`categoryDisplay` come from the same catalog entry, so the
// order cart can group a panel's tests under the section they belong to instead
// of an untitled bucket.
export const sharedTestPanelsGet = oc
  .route({ method: 'GET', path: '/v2/shared-test-panels' })
  .input(
    z
      .object({
        vendor: z.string().optional(),
      })
      .optional(),
  )
  .output(
    z.object({
      panels: z.array(
        z.object({
          id: z.string(),
          name: z.string(),
          vendor: z.string(),
          tests: z.array(
            z.object({
              code: z.string(),
              name: z.string().nullable(),
              specimen: z.string().optional(),
              category: z.string().optional(),
              categoryDisplay: z.string().optional(),
            }),
          ),
        }),
      ),
    }),
  )
